console.log('OSB'); // OSB = Old sticky bar. Console hint on which pages this script can be removed.
/* (function() {
	'use strict';
	try {
 
		

		var
			stickyBars = document.querySelectorAll('.sticky-bar'),
			buttons = document.querySelectorAll('.sticky-bar a'),
			waypoint = '.sticky-waypoint',
			table = '.tables-common.sticky-header, .tables.tables--sticky',
			tableTop = '.tables-common.sticky-header thead, .tables.tables--sticky thead',
			waypoints = avm.require('avast.web.waypoints');


		// (un)set all sticky bar buttons to be tabable
		function changeTabindex(value) {
			buttons.forEach(function(button){
				button.setAttribute('tabindex', value);
			});
		}

		// (un)set class to sticky bar
		function makeSticky(bool) {
			stickyBars.forEach(function(bar){
				if (bool) {
					bar.classList.add('is-sticky');
					changeTabindex(0);
				} else {
					bar.classList.remove('is-sticky');
					changeTabindex(-1);
				}
			});
		}

		// sticky params changes logic
		function stickyParams() {
			if (
				waypoints(waypoint, null, null, true) // sticky-waypoint is on top or above viewport AND
				&& (
					!waypoints(tableTop, -64, null, true) // top of the sticky table (minus height of the bar) is above viewport OR
					|| !waypoints(table) // table is in viewport
				)
			) {
				makeSticky(true);
			} else {
				makeSticky(false);
			}
		}

		// initially disable all sticky bar buttons from tabbing scope
		changeTabindex(-1);
		

		// event listeners assignment only if waypoint class exists
		if (waypoint) {
			window.addEventListener('scroll', function () {
				stickyParams();
			});

			window.addEventListener('resize', function () {
				stickyParams();
			});
		}
		

	} catch (error) {
		// singe data layer error tracking
		if (typeof sdl !== 'undefined') {
			console.error(error);
			sdl.push({
				system: {
					error: {
						type: error.name,
						message: error.message,
					}
				},
				event: 'system.error'
			});
		}
	}
})();
 */